<div [class.rc-loader--relative]="relativePosition" class="rc-loader">
  <div [class.no-mobile]="noMobileDisplay" class="rc-loader__container">
    <div class="rc-loader__container__circular"></div>
    @if (env.isRoyalCanin) {
      <img
        [src]="'assets/images/logo_rc.svg'"
        class="rc-loader__container__logo"
        role="presentation"
        alt=""
      />
    }
  </div>
</div>
